module.exports={TICKET:{STARTING_FROM:"TICKETS ➔"},MASONRY:{SEARCH:{CATEGORIES:"Kategorie auswählen"}}};